<template>
  <div>
    <router-view></router-view>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  mounted() {},
  computed: {},
  methods: {},
  components: {}
};
</script>
<style >
img {
  width: 100%;
  max-width: 100%;
}
.van-picker-column__item {
  font-size: 21px;
}
.van-cell {
  font-size: 18px !important;
}
</style>
